export interface Counter {
    hit: (...args: unknown[]) => void;
    params: (...args: unknown[]) => void;
    userParams: (...args: unknown[]) => void;
    reachGoal: (...args: unknown[]) => void;
    reachGoals: (...args: unknown[]) => void;
}

export interface CounterConfig {
    id: number;
    name: string;
}

export interface QueueItem {
    method: 'hit' | 'params' | 'userParams' | 'reachGoal';
    args: unknown[];
}

export enum Counters {
    Main = 'main',
    Cross = 'cross',
}

export type WindowWithMetrika = typeof window & {
    [key: string]: unknown;
};
